import { useEffect } from "react";
import { logUser } from "../api";

export function useUser() {
    useEffect(() => {
        if (window.Telegram?.WebApp?.initDataUnsafe?.user) {

            const user = window.Telegram.WebApp.initDataUnsafe.user;
            logUser(user);
        }
    }, []);
}
